<template>
  <v-btn
    v-if="me && me.id === id"
    to="/passwordChange"
    class="primary accent-4 white--text mr-2 my-1"
    small
  >
    {{ $t("profile.assignment.changePassword") }}
  </v-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["id"],
  computed: {
    ...mapState(["me"])
  }
};
</script>
